export enum ApplicationMethodEnum{
    EmailPhoneAddress = 1,
    ViaWebsite = 2,
    RedirectToUrl = 3,
}